export const contactKeys = {
    all: ['mark', 'contacts'],
    list: () => [...contactKeys.all, 'list'],
    listFor: (params) => [...contactKeys.list(), params],
    detail: (profileId) => [...contactKeys.all, 'detail', profileId],
    engagementRoot: (profileId) => [...contactKeys.all, 'engagement', profileId],
    engagement: (profileId, params) => [...contactKeys.engagementRoot(profileId), params],
    demoListRoot: () => [...contactKeys.all, 'demo'],
    demoList: (params) => [...contactKeys.demoListRoot(), params]
};
export const templateKeys = {
    all: ['mark', 'templates'],
    doc: (target) => [...templateKeys.all, 'doc', target],
    editorContext: (target) => [...templateKeys.all, 'editorContext', target],
    validate: (docHash, targetKind, subject, library = false) => [
        ...templateKeys.all,
        'validate',
        docHash,
        targetKind,
        subject,
        ...(library ? ['library'] : [])
    ],
    rows: (parent) => [...templateKeys.all, 'rows', parent],
    row: (id) => [...templateKeys.all, 'row', id]
};
export const blastKeys = {
    all: ['mark', 'blasts'],
    list: () => [...blastKeys.all, 'list'],
    listFor: (params) => [...blastKeys.list(), params],
    detail: (blastId) => [...blastKeys.all, 'detail', blastId],
    validate: (blastId) => [...blastKeys.all, 'validate', blastId],
    stats: (blastId, status) => [...blastKeys.all, 'stats', blastId, ...(status != null ? [status] : [])]
};
export const dripKeys = {
    all: ['mark', 'drips'],
    list: () => [...dripKeys.all, 'list'],
    listFor: (params) => [...dripKeys.list(), params],
    detailRoot: (id) => [...dripKeys.all, 'detail', id],
    detail: (id, versionNumber) => [...dripKeys.detailRoot(id), versionNumber ?? 'live'],
    versionsRoot: (id) => [...dripKeys.all, 'versions', id],
    versions: (id, params) => [...dripKeys.versionsRoot(id), params],
    statsRoot: (id) => [...dripKeys.all, 'stats', id],
    stats: (id, params) => [...dripKeys.statsRoot(id), params],
    validate: (id) => [...dripKeys.all, 'validate', id]
};
export const segmentKeys = {
    all: ['mark', 'segments'],
    list: (params) => [...segmentKeys.all, 'list', params],
    allForPicker: () => [...segmentKeys.all, 'list', 'all-for-picker'],
    detail: (id) => [...segmentKeys.all, 'detail', id],
    attributes: () => [...segmentKeys.all, 'attributes']
};
